module.exports = __webpack_public_path__ + "img/V-L-6-unload-connect.67de15db.png";